
import { Prop } from 'nuxt-property-decorator';
import Component, { mixins } from 'vue-class-component';
import BaseCmsBlock from '../CmsBlockMixin';

@Component
export default class DefaultBlock extends mixins(BaseCmsBlock) {
	@Prop({ type: String })
	blockName!: string;
}
